import type { History } from 'history';
import { formatUrl, NullableUrlParams } from 'url-lib';

/**
 * Replaces the specified history object with the specified request parameters
 * (particularly useful for initial server rendering)
 * @param routerHistory The history object
 * @param params
 */
export const updateHistory = (
    routerHistory: History,
    { path, params }: { path: string; params: NullableUrlParams },
) => {
    routerHistory.replace(formatUrl(path, params));
};
